// media-fade.js — global image fade-in for the placeholder utility (assets/base.css .media-ph).
//
// Opt-in per image via the `media-fade` class. An image starts VISIBLE (CSS default opacity 1),
// so if this script never runs the image still shows — fail-safe. Here we set opacity 0 ONLY for
// images that haven't loaded yet (already-loaded eager/cached images are left untouched, so they
// never flash), then fade them to 1 on load. A not-yet-loaded <img> is transparent anyway, so
// dropping it to 0 is visually identical — no flash — and the .media-ph placeholder shows through
// until the pixels arrive.
//
// A MutationObserver arms images added later (collection infinite-scroll, zoom <template> clones,
// Embla — anything inserted after first paint).
(function () {
  function arm(img) {
    if (img.__fadeArmed) return;
    img.__fadeArmed = true;
    if (img.complete && img.naturalWidth > 0) return; // already loaded — leave visible, no fade
    img.style.opacity = '0';
    var reveal = function () { img.style.opacity = '1'; };
    // Reveal only once the pixels are decoded & paint-ready. `load` can fire a frame or two before
    // paint (decoding="async"); img.decode() closes that gap. It's called AFTER load, so it never
    // forces a lazy image to fetch early. then(reveal, reveal) → a decode abort still reveals.
    var onLoad = function () {
      if (img.decode) { img.decode().then(reveal, reveal); }
      else { reveal(); }
    };
    img.addEventListener('load', onLoad, { once: true });
    img.addEventListener('error', reveal, { once: true }); // never leave a broken image hidden
  }

  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches('img.media-fade')) arm(root);
    if (root.querySelectorAll) root.querySelectorAll('img.media-fade').forEach(arm);
  }

  scan(document);

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) scan(added[j]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
